// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: "https://localhost:5006/api",
  apiUrl: "https://zb-lditsolutionsbk-api.azurewebsites.net/api",
  firebaseConfig : {
    apiKey: "AIzaSyC5EXiWheHsSNhXin2IS0kB2VQvMOHiVr8",
    authDomain: "zulu-bangy.firebaseapp.com",
    projectId: "zulu-bangy",
    storageBucket: "zulu-bangy.appspot.com",
    messagingSenderId: "230090787154",
    appId: "1:230090787154:web:c2b2c51e176ef12b63128b",
    measurementId: "G-1NS1FEBWK2"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
